import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ui-icon-sidebar-show',
    templateUrl: './icon-sidebar-show.component.svg',
    styleUrls: ['../icon-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class IconSidebarShowComponent { }
